import { useEffect, useState } from "react";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import toast from "react-hot-toast";
import { isValidURL } from "../../utils/isValidUrl";

const Settings = () => {
  const [loading, setLoading] = useState(true);
  const [isChanged, setIsChanged] = useState(false);
  const [logo, setLogo] = useState({ url: "", obj: "" });
  const [logoAlt, setLogoAlt] = useState("");
  const [logoCaption, setLogoCaption] = useState("");
  const [socialMedia, setSocialMedia] = useState([]);
  const [notFoundLink, setNotFoundLink] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getAllApi("settings")
      .then((res) => {
        const data = res.data[0];

        setLogo({ url: data?.logo || "", obj: "" });
        setLogoAlt(data?.logoAlt);
        setLogoCaption(data?.logoCaption);
        setNotFoundLink(data?.notFoundLink);
        setSocialMedia(
          data.socialMedia.map((v) => ({ ...v, img: { url: v.img, obj: "" } }))
        );
        setId(data?._id);
        setIsChanged(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const validate = () => {
    if (!logo?.url) {
      toast.error("Logo is required.");
      return false;
    }

    if (!logoAlt) {
      toast.error("Logo Alt is required.");
      return false;
    }

    if (!logoCaption) {
      toast.error("Logo Caption is required.");
      return false;
    }

    if (!notFoundLink) {
      toast.error("404 Link is required.");
      return false;
    }

    if (!isValidURL(notFoundLink)) {
      toast.error("404 link is invalid.");
      return false;
    }

    if (socialMedia.length === 0) {
      toast.error("Social Media Links are required.");
      return false;
    }

    for (let i = 0; i < socialMedia.length; i++) {
      let sm = socialMedia[i];

      if (!sm.img.url) {
        toast.error("Social Media Icon is required.");
        return false;
      }

      if (!sm.iconAlt) {
        toast.error("Social Media Icon Alt is required.");
        return false;
      }

      if (!sm.iconCaption) {
        toast.error("Social Media Icon Caption is required.");
        return false;
      }

      if (!sm.name) {
        toast.error("Social Media Name is required.");
        return false;
      }

      if (!sm.link) {
        toast.error("Social Media Link is required.");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (validate()) {
      let data = {
        logoAlt,
        logoCaption,
        notFoundLink,
      };
      const r = await uploadImageApi(logo.obj);
      data.logo = r.data.imageUrl;

      let sm = [];

      for (let i = 0; i < socialMedia.length; i++) {
        if (socialMedia[i].img.obj) {
          const rr = await uploadImageApi(socialMedia[i].img.obj);
          sm.push({ ...socialMedia[i], img: rr.data.imageUrl });
        } else {
          sm.push({ ...socialMedia[i], img: socialMedia[i].img.url });
        }
      }

      data.socialMedia = sm;

      console.log("Data : ", data);

      addUpdateApi({ data, type: "settingsPage", method: "put", id })
        .then((res) => {
          toast.success("Updated Successfully.");
          getData();
        })
        .catch((err) => {
          toast.error("Something went wrong while updating settings.");
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Content>
        <ContentHead
          title="Settings"
          showBtn1={isChanged}
          btn1Text="Save"
          btn1type="filled"
          btn1Name="btn1"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleSubmit();
            } else {
              setLoading(true);
              getData();
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>Settings</h3>
              <div>
                <p style={{ fontSize: ".9rem" }}>Logo</p>
                {logo?.url ? (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                      position: "relative",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faClose}
                      style={{
                        color: "var(--blue-dark)",
                        cursor: "pointer",
                        height: "15px",
                        width: "15px",
                        padding: "5px",
                        position: "absolute",
                        top: 0,
                        right: 0,
                        transform: "translate(50%, -50%)",
                      }}
                      onClick={() => {
                        setLogo({ url: "", obj: "" });
                        setIsChanged(true);
                      }}
                    />
                    <img
                      src={logo?.url}
                      alt=""
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      width: "70px",
                      height: "70px",
                      position: "relative",
                      background: "var(--blue-light)",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "5px",
                    }}
                  >
                    <input
                      type="file"
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        opacity: 0,
                      }}
                      accept="image/*"
                      onChange={(e) => {
                        setLogo({
                          url: URL.createObjectURL(e.target.files[0]),
                          obj: e.target.files[0],
                        });
                        setIsChanged(true);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={faPlus}
                      style={{ color: "var(--blue-dark)" }}
                    />
                  </div>
                )}
              </div>
              {logo?.url && (
                <div className="grid_2">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Caption"}
                    value={logoCaption}
                    onChange={(e) => {
                      setLogoCaption(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Image Alt"}
                    value={logoAlt}
                    onChange={(e) => {
                      setLogoAlt(e.target.value);
                      setIsChanged(true);
                    }}
                  />
                </div>
              )}
              <div className="grid_2">
                <InputField
                  type="text"
                  isLabel={true}
                  lable="404 Page Redirect Link"
                  value={notFoundLink}
                  onChange={(e) => {
                    setNotFoundLink(e.target.value);
                    setIsChanged(true);
                  }}
                />
              </div>
              <h3>
                Social Medias
                <button
                  onClick={() => {
                    setSocialMedia((prev) => [
                      ...prev,
                      {
                        name: "",
                        img: { url: "", obj: "" },
                        iconAlt: "",
                        iconCaption: "",
                        link: "",
                      },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  Add
                </button>
              </h3>
              <>
                {socialMedia.map((val, index) => {
                  return (
                    <div className="sub_card grid">
                      <FontAwesomeIcon
                        icon={faClose}
                        className="sub_card_close"
                        onClick={() => {
                          const temp = [...socialMedia];
                          temp.splice(index, 1);
                          setSocialMedia(temp);
                          setIsChanged(true);
                        }}
                      />
                      <div>
                        <p style={{ fontSize: ".9rem" }}>Icon</p>
                        {val?.img?.url ? (
                          <div
                            style={{
                              width: "70px",
                              height: "70px",
                              background: "var(--blue-light)",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: "5px",
                              position: "relative",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faClose}
                              style={{
                                color: "var(--blue-dark)",
                                cursor: "pointer",
                                height: "15px",
                                width: "15px",
                                padding: "5px",
                                position: "absolute",
                                top: 0,
                                right: 0,
                                transform: "translate(50%, -50%)",
                              }}
                              onClick={() => {
                                const temp = [...socialMedia];
                                temp[index].img = { url: "", obj: "" };
                                setSocialMedia(temp);
                                setIsChanged(true);
                              }}
                            />
                            <img
                              src={val?.img?.url}
                              alt=""
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              width: "70px",
                              height: "70px",
                              position: "relative",
                              background: "var(--blue-light)",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: "5px",
                            }}
                          >
                            <input
                              type="file"
                              style={{
                                position: "absolute",
                                top: 0,
                                bottom: 0,
                                left: 0,
                                right: 0,
                                opacity: 0,
                              }}
                              accept="image/*"
                              onChange={(e) => {
                                const temp = [...socialMedia];
                                temp[index].img = {
                                  url: URL.createObjectURL(e.target.files[0]),
                                  obj: e.target.files[0],
                                };
                                setSocialMedia(temp);
                                setIsChanged(true);
                              }}
                            />
                            <FontAwesomeIcon
                              icon={faPlus}
                              style={{ color: "var(--blue-dark)" }}
                            />
                          </div>
                        )}
                      </div>
                      {val?.img?.url && (
                        <div className="grid_2">
                          <InputField
                            type="text"
                            isLabel={true}
                            lable={"Icon Caption"}
                            value={val?.iconCaption}
                            onChange={(e) => {
                              const temp = [...socialMedia];
                              temp[index].iconCaption = e.target.value;
                              setSocialMedia(temp);
                              setIsChanged(true);
                            }}
                          />
                          <InputField
                            type="text"
                            isLabel={true}
                            lable={"Icon Alt"}
                            value={val?.iconAlt}
                            onChange={(e) => {
                              const temp = [...socialMedia];
                              temp[index].iconAlt = e.target.value;
                              setSocialMedia(temp);
                              setIsChanged(true);
                            }}
                          />
                        </div>
                      )}
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable="Name"
                          value={val?.name}
                          onChange={(e) => {
                            const temp = [...socialMedia];
                            temp[index].name = e.target.value;
                            setSocialMedia(temp);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable="Link"
                          value={val?.link}
                          onChange={(e) => {
                            const temp = [...socialMedia];
                            temp[index].link = e.target.value;
                            setSocialMedia(temp);
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </>
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default Settings;
